import { useContent } from "../../Core/Content/Provider";
import { RouteConstants } from "../../Core/Constants/RouteConstants";
import { PageHeaderPiece } from "../../Shared/Layout/Pieces";
import { ButtonPiece } from "../../Shared/UI/ButtonPiece";
import { getServiceOfferingsFn } from "./Functions";
import { ServiceCardPiece } from "./Pieces";

export const ServicesComponent = () => {
  const content = useContent("services");
  const services = getServiceOfferingsFn();

  return (
    <section className="section-shell">
      <PageHeaderPiece
        eyebrow={content.eyebrow}
        title={content.title}
        description={content.description}
      />
      <div className="grid gap-6 lg:grid-cols-2 xl:grid-cols-3">
        {services.map((service, index) => (
          <ServiceCardPiece index={index} key={service.id} service={service} />
        ))}
      </div>
      <div className="mt-10 flex flex-wrap gap-3">
        <ButtonPiece appearance="secondary" to={RouteConstants.booking}>
          Book a Session
        </ButtonPiece>
        <ButtonPiece appearance="ghost" to={RouteConstants.packages}>
          Compare Packages
        </ButtonPiece>
        <ButtonPiece appearance="ghost" to="/packages#film-production">
          Film & Production Pricing
        </ButtonPiece>
      </div>
    </section>
  );
};
